<template>
    <div id="app">
        <main role="main" class="main-cont">
            <div class="row m-0 main-section">
                <div class="col-sm-12 right-section homebody">
                    <div class="row" style="margin-top:30px;">
                        <div class="col-sm-2 ">
                        </div>
                        <div class="col-sm-8 card bg-light">
                            <div class="row" style="margin-top: 20px;margin-bottom: 20px;">
                                <div class="col">
                                    <h4 class="mb-4">Header Configuration/ Add New Client</h4>
                                </div>
                            </div>
                            <div class="panelDiv">
                                <!-- Button to Open the Modal -->
                                <button v-if="appName !== 'BRC'"
                                        id="addClientBtn"
                                        type="button"
                                        class="btn btn-primary"
                                        data-toggle="modal"
                                        data-target="#addClientModal"
                                        @click="resetModal">
                                    Add new client
                                </button>

                                <!-- Button to Open the Modal -->

                                <button id="addHeaderBtn"
                                        type="button"
                                        class="btn btn-primary float-right"
                                        data-toggle="modal"
                                        data-target="#createHeaderModal"
                                        @click="resetModal">
                                    Header Configuration
                                </button>
                                <div class="container">
                                    <div style="padding-bottom: 20px;">
                                        <div class="float-left" style="margin-left:30px;">
                                            <h4></h4>
                                        </div>

                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <!---------------Modal to Create New Headers Starts Here------------->
                                    <div class="container">
                                        <div class="modal" id="createHeaderModal">
                                            <form data-vv-scope="create">
                                                <div class="modal-dialog">
                                                    <div class="modal-content">

                                                        <div class="modal-header">
                                                            <h5 class="modal-title">Add Headers</h5>
                                                            <button type="button" id="createHeaderBtn" class="close" data-dismiss="modal" aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div>
                                                        <div class="modal-body">
                                                            <div v-if="showBankName" class="row">
                                                                <div class="col-md-4 col-lg-4">
                                                                    <label>Bank Name : <span class="required">*</span></label>
                                                                </div>
                                                                <div class="col-md-7 col-lg-7">
                                                                    <select class="form-control selectarrow" v-model="createNewOption.bankName" v-on:change="MapClients()" v-validate="'required'" name="addBankName" :class="{'is-invalid':errors.has('create.addBankName')}">
                                                                        <option value="" selected disabled>---Please Select---</option>
                                                                        <option v-for="bank in bankList" :value="bank.bankName"
                                                                                :key="bank.bankId">
                                                                            {{ bank.bankName }}
                                                                        </option>
                                                                    </select>
                                                                </div>

                                                                <div class="offset-md-5 offset-lg-5">
                                                                    <span v-show="errors.has('create.addBankName')"
                                                                          class="text-danger">Please Enter Valid Bank Name  </span>
                                                                </div>

                                                            </div>
                                                            <br />

                                                            <div class="row">
                                                                <div class="col-md-4 col-lg-4">
                                                                    <label>Client Name : <span class="required">*</span></label>
                                                                </div>
                                                                <div class="col-md-7 col-lg-7">
                                                                    <select class="form-control selectarrow" v-model="createNewOption.clientName" v-validate="'required'" name="addClientName" :class="{'is-invalid':errors.has('create.addClientName')}">
                                                                        <option value="" selected disabled>---Please Select---</option>
                                                                        <option v-for="client in clientList" :value="client.clientName" :key="client.clientId" v-bind:value="{ id: client.id, text: client.clientName }">{{ client.clientName }}</option>
                                                                    </select>
                                                                </div>

                                                                <div class="offset-md-5 offset-lg-5">
                                                                    <span v-show="errors.has('create.addClientName')"
                                                                          class="text-danger">Please Enter Valid Client Name </span>
                                                                </div>

                                                            </div>
                                                            <br />
                                                            <div class="row">
                                                                <div class="col-md-4 col-lg-4">
                                                                    <label>File Type : <span class="required">*</span></label>
                                                                </div>
                                                                <div class="col-md-7 col-lg-7">
                                                                    <select class="form-control selectarrow" v-model="createNewOption.fileType" v-validate="'required'" name="addFileType" v-on:change="getDbColumns()" :class="{'is-invalid':errors.has('create.addFileType')}">
                                                                        <option value="" selected disabled>---Please Select---</option>
                                                                        <option v-for="file in fileList" :value="file.fileType">{{ file.fileType }}</option>
                                                                    </select>
                                                                </div>

                                                                <div class="offset-md-5 offset-lg-5">
                                                                    <span v-show="errors.has('create.addFileType')"
                                                                          class="text-danger">Please Enter Valid File Type</span>
                                                                </div>

                                                            </div>
                                                            <br />
                                                            <div class="row">
                                                                <div class="col-md-4 col-lg-4">
                                                                    <label>Db Column : <span class="required">*</span></label>
                                                                </div>
                                                                <div class="col-md-7 col-lg-7">
                                                                    <select class="form-control selectarrow" v-model="createNewOption.dbColumnName" v-validate="'required'" name="addDbColumn" :class="{'is-invalid':errors.has('create.addDbColumn')}">
                                                                        <option value="" selected disabled>---Please Select---</option>
                                                                        <option v-for="db in dbList">{{ db.dbColumnName }}</option>
                                                                    </select>
                                                                </div>

                                                                <div class="offset-md-5 offset-lg-5">
                                                                    <span v-show="errors.has('create.addDbColumn')"
                                                                          class="text-danger">Please Enter Valid Db Column </span>
                                                                </div>
                                                            </div>
                                                            <br />
                                                            <div class="row">
                                                                <div class="col-md-4 col-lg-4">
                                                                    <label>Excel Column : <span class="required">*</span></label>
                                                                </div>
                                                                <div class="col-md-7 col-lg-7">
                                                                    <input v-model='createNewOption.excelColumnName' class="form-control" type="text" name="addExcelColumnName" v-validate="'required|headersValidator'" :class="{'is-invalid':errors.has('create.addExcelColumnName')}" placeholder="Enter Excel Column">
                                                                </div>

                                                                <div class="offset-md-5 offset-lg-5">
                                                                    <span v-show="errors.has('create.addExcelColumnName')"
                                                                          class="text-danger">Please Enter Valid Excel Column </span>
                                                                </div>
                                                            </div>
                                                            <input v-model="createNewOption.userDetails.userId" type="hidden" />
                                                            <input v-model="createNewOption.userDetails.firstName" type="hidden" />
                                                            <input v-model="createNewOption.userDetails.lastName" type="hidden" />
                                                            <input v-model="createNewOption.userDetails.appName" type="hidden" />
                                                            <input v-model="createNewOption.appId" type="hidden" />
                                                            <br />
                                                            <div class="modal-footer">
                                                                <div class="footer-text">
                                                                    <p>{{footerText}}</p>
                                                                </div>
                                                                <button type="button" id="cancelAddHeadersButton" data-dismiss="modal" class="btn btn-default">Cancel</button>
                                                                <button type="button" id="addHeadersButton" v-on:click="saveHeader(createNewOption)" class="btn btn-primary">Save</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <!---------------Modal to Create New Headers Ends Here------------->
                                    <!---------------Alert Modal Starts Here----------------->
                                    <div class="modal" tabindex="-1" role="dialog" id="statusAlertModal">
                                        <div class="modal-dialog" role="document">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h5 class="modal-title">Status</h5>
                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div class="modal-body">
                                                    <p>{{this.statusMessage}}</p>
                                                </div>
                                                <div class="modal-footer">
                                                    <button type="button" class="btn btn-primary" data-dismiss="modal">Okay</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!---------------Alert Modal Ends Here----------------->
                                    <!---------------Modal to Edit Headers Starts Here----------------->

                                    <div class="container">
                                        <div class="modal" id="editHeadersModal">
                                            <form data-vv-scope="edit">
                                                <div class="modal-dialog">
                                                    <div class="modal-content">
                                                        <div class="modal-header">
                                                            <h5 class="modal-title">Edit Headers</h5>
                                                            <button type="button" id="editHeaderBtn" class="close" data-dismiss="modal" aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div>
                                                        <div class="modal-body">

                                                            <div class=" row">
                                                                <div v-if="showBankName" class="col-sm-12 col-md-12 col-lg-12">
                                                                    <label>Bank Name</label>
                                                                    <input disabled v-model='selectedOption.bankName' class="form-control" type="text">

                                                                </div>
                                                                <div class="col-sm-12 col-md-12 col-lg-12">
                                                                    <label>Client Name</label>
                                                                    <input disabled="disabled" v-model='selectedOption.clientName' class="form-control" type="text">
                                                                </div>
                                                                <div class="col-sm-12 col-md-12 col-lg-12">
                                                                    <label>File Type</label>
                                                                    <input disabled="disabled" v-model='selectedOption.fileType' class="form-control" type="text">
                                                                </div>
                                                                <div class="col-sm-12 col-md-12 col-lg-12">
                                                                    <label>Db Column</label>
                                                                    <input disabled="disabled" v-model='selectedOption.dbColumnName' class="form-control" type="text">
                                                                </div>
                                                                <div class="col-sm-12 col-md-12 col-lg-12">
                                                                    <label>Excel Column <span class="required">*</span></label>
                                                                    <input v-model='selectedOption.excelColumnName' v-validate="'required|headersValidator'" class="form-control" type="text" name="excelColumn" :class="{'is-invalid':errors.has('edit.excelColumn')}" placeholder="Enter Excel Column">
                                                                    <div>
                                                                        <span v-show="errors.has('edit.excelColumn')"
                                                                              class="text-danger">Please Enter Valid Excel Column </span>
                                                                    </div>

                                                                </div>
                                                                <input v-model='selectedOption.columnHeaderId' class="form-control" type="hidden">
                                                                <input v-model='selectedOption.mappingId' class="form-control" type="hidden">
                                                                <input v-model="selectedOption.userDetails.userId" type="hidden" />
                                                                <input v-model="selectedOption.userDetails.firstName" type="hidden" />
                                                                <input v-model="selectedOption.userDetails.lastName" type="hidden" />
                                                                <input v-model="selectedOption.appId" type="hidden" />
                                                            </div>

                                                        </div>
                                                        <div class="modal-footer">
                                                            <button type="button" id="cancelEditHeadersButton" v-on:click="reset()" data-dismiss="modal" class="btn btn-default">Cancel</button>
                                                            <button type="button" id="saveHeadersButton" v-on:click="saveHeader(selectedOption)" class="btn btn-primary">Save</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <!---------------Modal to Edit Headers Starts Here------------------->
                                    <!---------------Modal to Delete Headers Starts Here----------------->
                                    <div class="container">
                                        <div class="modal" id="deleteHeadersModal">
                                            <div class="modal-dialog">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title">Delete Header</h5>
                                                        <button type="button" id="btnDeleteId" class="close" data-dismiss="modal" aria-label="Close">
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </div>
                                                    <div class="modal-body">
                                                        {{deleteMessage}}
                                                        <input v-model='selectedOption' class="form-control" type="hidden">
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button type="button" id="deleteHeadersButton" v-on:click="deleteHeader(selectedOption)" data-dismiss="modal" class="btn btn-default">Confirm</button>
                                                        <button type="button" id="cancelHeadersButton" data-dismiss="modal" class="btn btn-primary">Cancel</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!---------------Modal to Add Client in Header Configuration Ends Here----------------->
                                    <div class="container">
                                        <div class="row">
                                            <div class="modal" id="addClientModal">
                                                <div class="modal-dialog">
                                                    <div class="modal-content">
                                                        <div class="modal-header">
                                                            <h5 class="modal-title">Add Client</h5>
                                                            <button type="button" id="btnAddClientId" class="close" data-dismiss="modal" aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div>
                                                        <div class="modal-body">
                                                            <div class="container" v-if="adddialog">
                                                                <label>Client Name</label>
                                                                <input type="text"
                                                                       class="form-control"
                                                                       list="clientdetails"
                                                                       v-model="addedClientName"
                                                                       v-validate="'required'"
                                                                       v-on:change="handleUpdatedClient()"
                                                                       name="cname" />
                                                                <datalist id="clientdetails">
                                                                    <option v-for="(clientitem,index) in clientArray"
                                                                            v-bind:key="'clientitem.clientId'+index">
                                                                        {{clientitem.clientName}}
                                                                    </option>
                                                                </datalist>
                                                                <div>
                                                                    <span v-show="errors.has('cname')"
                                                                          class="text-danger">Please select a valid Client name</span>
                                                                </div>
                                                            </div>
                                                            <div class="container" v-if="addmessagedialog">
                                                                <div class="alert alert-info">
                                                                    <strong>{{statusMessage}}</strong>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="modal-footer">
                                                            <button type="button" id="addClientButton" v-on:click="addClient" class="btn btn-primary" v-if="adddialog">Confirm</button>
                                                            <button type="button" id="cancelClientButton" data-dismiss="modal" class="btn btn-default" v-on:click="resetModal">Cancel</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!---------------Modal to Delete Headers Ends Here----------------->
                                    <br />
                                    <div v-if="loading" class="spinner__icon spinner__icon--xxlarge spinner_position">
                                    </div>
                                    <!---------------Data TableStarts Here----------------------------->
                                    <div class="panelDiv">
                                        <div class="container">
                                            <div class="container">
                                                <div class="row col-sm-12">
                                                    <div class="col">
                                                        <table id="headersTable"
                                                               class="table table-striped table table-striped display table-bordered"
                                                               cellspacing="0"
                                                               width="100%">
                                                            <thead>
                                                                <tr>
                                                                    <th class="hide">Column ID</th>
                                                                    <th class="hide">Mapping ID</th>
                                                                    <th v-if="showBankName">Bank</th>
                                                                    <th>Client</th>
                                                                    <th>File</th>
                                                                    <th data-orderable>Excel </th>
                                                                    <th data-orderable>DB </th>
                                                                    <th data-orderable="false">Edit</th>
                                                                    <th data-orderable="false">Delete</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody></tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!---------------DataTable Ends Here--------------------->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </main>
    </div>
</template>





<script>
    import CommonService from '../../services/SharedService/common.service.js';
    import ACRService from "../../services/ACRService/ACR.service.js";
    import Algorithm from "../../services/Algorithm.js";
    import { EnvironmentConfig } from '../../services/constants.js';
    import $ from 'jquery';
    export default {
        name: 'AdminHeader',
        data() {
            return {
                appName: localStorage.getItem('appKey'),
                dataTable: null,
                adddialog: true,
                showBankName: false,
                columnHeadersList: [],
                deleteMessage: 'Are you sure to delete this item?',
                footerText: 'indicates mandatory fields',
                loading: false,
                statusMessage: '',
                addmessagedialog: false,
                editSubmit: false,
                clientArray: [],
                addedClientName: '',
                addedClientId: '',
                editedClientName: '',
                editedClientId: '',
                selectedOption: {
                    bankName: '',
                    clientName: '',
                    fileType: '',
                    dbColumnName: '',
                    excelColumnName: '',
                    columnHeaderId: '',
                    mappingId: '',
                    appId: '',
                    userDetails: {
                        userId: '',
                        firstName: '',
                        lastName: '',
                        appName: ''
                    }
                },
                createNewOption: {
                    bankName: '',
                    clientName: '',
                    fileType: '',
                    dbColumnName: '',
                    excelColumnName: '',
                    columnHeaderId: null,
                    mappingId: '',
                    appId: localStorage.getItem('appId'),
                    userDetails: {
                        userId: localStorage.getItem('userId'),
                        firstName: localStorage.getItem('firstName'),
                        lastName: localStorage.getItem('lastName'),
                        appName: localStorage.getItem('appKey')
                    }
                },
                bankList: [],
                clientList: [],
                bankAndClient: [],
                fileList: [],
                dbList: [],
                client: []
            }
        },
        mixins: [CommonService, ACRService, Algorithm],
        created() {
            this.loading = true;
            localStorage.setItem("route", this.$route.name);
            var appKey = localStorage.getItem('appKey');
            if (appKey == 'BRC') {
                this.showBankName = true;
                this.loadBanks();
            }
            else {
                this.showBankName = false;
                this.loadClients();
            }
            this.loadFileTypes();
        },
        mounted() {
            this.dataTable = $("#headersTable").DataTable({
                "order": [],
                columnDefs: [
                    { visible: false, targets: [0, 1] }
                ],
                fixedColumns: true
            });
            var table = this.dataTable;
            var appKey = localStorage.getItem('appKey');
            this.GetFileHeaders().then(response => {
                if (response) {
                    this.columnHeadersList = response.data;
                    this.columnHeadersList.forEach(columnItem => {
                        if (appKey == 'BRC') {
                            table.row
                                .add([columnItem.columnHeaderId, columnItem.mappingId, columnItem.bankName, columnItem.clientName, columnItem.fileType, columnItem.excelColumnName, columnItem.dbColumnName, '<a href="#" data="' + columnItem.columnHeaderId + '" class="ModifyBtn" >Edit </a>', '<a href="#" data="' + columnItem.columnHeaderId + '" class="DeleteBtn">Delete </a>'])
                                .draw(false);
                        }
                        else {
                            table.row
                                .add([columnItem.columnHeaderId, columnItem.mappingId, columnItem.clientName, columnItem.fileType, columnItem.excelColumnName, columnItem.dbColumnName, '<a href="#" data="' + columnItem.columnHeaderId + '" class="ModifyBtn" >Edit </a>', '<a href="#" data="' + columnItem.columnHeaderId + '" class="DeleteBtn">Delete </a>'])
                                .draw(false);
                        }
                    });
                    this.loading = false;
                    $('#headersTable tbody').on('click', '.ModifyBtn', (e) => {
                        this.selectedOption = this.columnHeadersList.find(x => x.columnHeaderId === e.currentTarget.attributes["data"].value);
                        this.selectedOption.appId = localStorage.getItem('appId');
                        this.selectedOption.userDetails.userId = localStorage.getItem('userId');
                        this.selectedOption.userDetails.firstName = localStorage.getItem('firstName');
                        this.selectedOption.userDetails.lastName = localStorage.getItem('lastName');
                        this.selectedOption.userDetails.appName = localStorage.getItem('appKey');
                        $('#editHeadersModal').modal('show')
                    });
                    $('#headersTable tbody').on('click', '.DeleteBtn', (e) => {
                        this.selectedOption = this.columnHeadersList.find(x => x.columnHeaderId === e.currentTarget.attributes["data"].value);
                        this.selectedOption.appId = localStorage.getItem('appId');
                        this.selectedOption.userDetails.userId = localStorage.getItem('userId');
                        this.selectedOption.userDetails.firstName = localStorage.getItem('firstName');
                        this.selectedOption.userDetails.lastName = localStorage.getItem('lastName');
                        this.selectedOption.userDetails.appName = localStorage.getItem('appKey');
                        $('#deleteHeadersModal').modal('show')
                    });
                }
            });
            this.GetClientDetails().then(response => {
                if (response) {
                    for (const item in response.data.clients) {
                        var clientdetails = {
                            clientId: response.data.clients[item].id,
                            clientName: response.data.clients[item].name
                        }
                        this.clientArray.push(clientdetails);
                    }
                }
            });
        },
        methods: {
            saveHeader(selectedItems) {
                var appKey = localStorage.getItem('appKey');
                if (selectedItems.columnHeaderId == null) { //Check if functionality is to add new headers or edit
                    if (selectedItems.mappingId == '' && appKey == "BRC") {
                        selectedItems.mappingId = this.getBankClientMappingId();

                    }
                    else if (selectedItems.mappingId == '' && appKey != "BRC") {
                        selectedItems.mappingId = selectedItems.clientName.id;

                    }
                    this.$validator.validateAll('create').then(valid => {
                        if (valid) {
                            this.SaveFileHeaders(selectedItems).then(response => {
                                if (response.data.result) {
                                    this.loading = true;
                                    this.HeadersRefresh();
                                    this.createNewOption.bankName = "";
                                    this.createNewOption.clientName = "";
                                    this.createNewOption.fileType = "";
                                    this.createNewOption.excelColumnName = "";
                                    this.createNewOption.dbColumnName = "";
                                    $('#createHeaderModal').modal('toggle');
                                    this.statusMessage = response.data.result;
                                    $('#statusAlertModal').modal('toggle');
                                    //this.loading = true;
                                }
                            });
                        }
                    });
                }
                else {
                    this.$validator.validateAll('edit').then(valid => {
                        if (valid) {
                            this.SaveFileHeaders(selectedItems).then(response => {
                                if (response.data.result) {
                                    this.loading = true;
                                    this.HeadersRefresh();
                                    $('#editHeadersModal').modal('toggle');
                                    this.statusMessage = "Header configuration saved successfully";
                                    $('#statusAlertModal').modal('toggle');
                                }
                            });
                        }
                    });
                }
            },
            deleteHeader(selectedItems) {
                this.DeleteFileHeader(selectedItems).then(response => {
                    if (response.data.result == "Success") {
                        this.loading = true;
                        this.HeadersRefresh();
                    }
                })
            },
            HeadersRefresh() {
                this.dataTable.clear().draw();
                var appKey = localStorage.getItem('appKey');
                this.GetFileHeaders().then(response => {
                    if (response) {
                        this.columnHeadersList = response.data;
                        this.columnHeadersList.forEach(columnItem => {
                            if (appKey == 'BRC') {
                                this.dataTable.row
                                    .add([columnItem.columnHeaderId, columnItem.mappingId, columnItem.bankName, columnItem.clientName, columnItem.fileType, columnItem.excelColumnName, columnItem.dbColumnName, '<a href="#" data="' + columnItem.columnHeaderId + '" class="ModifyBtn" >Edit </a>', '<a href="#" data="' + columnItem.columnHeaderId + '" class="DeleteBtn">Delete </a>'])
                                    .draw();
                            }
                            else {
                                this.dataTable.row
                                    .add([columnItem.columnHeaderId, columnItem.mappingId, columnItem.clientName, columnItem.fileType, columnItem.excelColumnName, columnItem.dbColumnName, '<a href="#" data="' + columnItem.columnHeaderId + '" class="ModifyBtn" >Edit </a>', '<a href="#" data="' + columnItem.columnHeaderId + '" class="DeleteBtn">Delete </a>'])
                                    .draw();
                            }
                        });
                        this.loading = false;
                    }
                }
                );
            },
            loadBanks() {
                this.BankClientMapping().then(response => {
                    if (response) {
                        this.bankAndClient = response.data;
                        sessionStorage.setItem('bankClientList', JSON.stringify(this.bankAndClient));
                        const map = new Map();
                        for (const item of this.bankAndClient) {
                            if (!map.has(item.bankId)) {
                                map.set(item.bankId, true);
                                this.bankList.push({
                                    bankId: item.bankId,
                                    bankName: item.bankname
                                });
                            }
                        }
                    }
                });
            },
            MapClients() {
                this.bankAndClient = JSON.parse(sessionStorage.getItem('bankClientList'));
                this.clientList = [];
                for (var i = 0; i < this.bankAndClient.length; i++) {
                    if (this.bankAndClient[i].bankname == this.createNewOption.bankName) {
                        this.clientList.push({
                            clientId: this.bankAndClient[i].clientId,
                            clientName: this.bankAndClient[i].clientname
                        });
                    }
                }
            },
            loadFileTypes() {
                this.GetFileTypes().then(response => {
                    if (response) {
                        this.headerColumns = response.data;
                        const map = new Map();
                        for (const item of this.headerColumns) {
                            if (!map.has(item.fileType)) {
                                map.set(item.fileType, true);
                                this.fileList.push({
                                    fileType: item.fileType
                                });
                            }
                        }
                    }
                });
            },
            getDbColumns() {
                this.dbList = [];
                for (var i = 0; i < this.headerColumns.length; i++) {
                    if (this.headerColumns[i].fileType == this.createNewOption.fileType) {
                        this.dbList.push({
                            dbColumnName: this.headerColumns[i].dbColumnName
                        });
                    }
                }
            },
            getBankClientMappingId() {
                this.bankAndClient = JSON.parse(sessionStorage.getItem('bankClientList'));
                for (var i = 0; i < this.bankAndClient.length; i++) {
                    if (
                        this.bankAndClient[i].bankname == this.createNewOption.bankName &&
                        this.bankAndClient[i].clientname == this.createNewOption.clientName.text
                    ) {

                        return this.bankAndClient[i].id;
                    }
                }
            },
            loadClients() {
                var appKey = localStorage.getItem('appKey');
                this.ClientMapping(appKey).then(response => {
                    if (response) {
                        this.clientList = response.data;
                        sessionStorage.setItem('clientList', JSON.stringify(this.clientList));
                    }
                });
            },
            handleUpdatedClient() {
                const temp = this.getClientIdByName(this.addedClientName);
                //this.addedClientId = this.getClientIdByName(this.addedClientName);
                this.editedClientName = this.addedClientName;
                this.editedClientId = temp;
            },
            getClientIdByName(editedName) {
                const temp = this.clientArray.find(item => item['clientName'] === editedName);
                //console.log(temp);
                if (temp != undefined) {
                    return temp.clientId;
                } else {
                    return null;
                }
            },
            addClient() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        const clientDetail = {
                            id: this.editedClientId,
                            name: this.editedClientName,
                            userdetails: {
                                userid: localStorage.getItem("userId"),
                                userName: localStorage.getItem("userName"),
                            }
                        };
                        this.SaveCitClient(clientDetail).then(response => {
                            if (response) {
                                var resp = response.data;
                                if (resp == "Failed") {
                                    this.adddialog = false;
                                    this.addmessagedialog = true;
                                    this.statusMessage = "Error occured during adding client.";
                                }
                                else {
                                    this.adddialog = false;
                                    this.addmessagedialog = true;
                                    this.statusMessage = "Client added successfully";
                                }
                            }
                            else {
                                this.adddialog = false;
                                this.addmessagedialog = true;
                                this.statusMessage = "";

                            }
                        }).catch(function () {
                            this.adddialog = false;
                            this.addmessagedialog = true;
                            this.statusMessage = "Error occured during adding client.";
                            $('#statusAlertModal').modal('toggle');
                        });
                    }
                });
            },
            resetModal() {
                this.addedClientName = '';
                this.addedClientId = '';
                this.adddialog = true;
                this.addmessagedialog = false;
                this.$validator.errors.clear();
                this.loadClients();
            }
        }
    }
</script>

<style>
    #addHeaderBtn {
        margin-right: 5px;
        width: 170px;
        float: right;
    }

    th, td {
        white-space: normal;
        word-break: break-all;
    }

    div.container {
        width: 100%;
    }

    td .a, .btn {
        cursor: pointer;
    }

    .header {
        text-align: center;
        margin-bottom: 2.5rem !important;
    }

    .deleteMsg {
        text-align: center;
        font-weight: bold;
    }

    .hide {
        display: none;
    }

    .required {
        color: red;
    }

    .footer-text p::before {
        content: "(*)";
        color: red;
    }

    .footer-text {
        padding-right: 195px;
        font-size: 9px;
    }

    table.dataTable th:nth-child(4),
    table.dataTable th:nth-child(5),
    table.dataTable th:nth-child(7) {
        width: 70px;
        max-width: 70px;
        word-break: break-all;
        white-space: pre-line;
    }

    table.dataTable td:nth-child(4),
    table.dataTable td:nth-child(5),
    table.dataTable td:nth-child(7) {
        width: 70px;
        max-width: 70px;
        word-break: break-all;
        white-space: pre-line;
    }
</style>